// ------------------------------------
// Constants
// ------------------------------------
// prettier-ignore
export const NETWORK_TUNNELS_POST_REQUEST = 'NETWORK_TUNNELS_POST_REQUEST';
// prettier-ignore
export const NETWORK_TUNNELS_POST_REQUEST_SUCCESS = 'NETWORK_TUNNELS_POST_REQUEST_SUCCESS';
// prettier-ignore
export const NETWORK_TUNNELS_POST_REQUEST_FAILURE = 'NETWORK_TUNNELS_POST_REQUEST_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: NETWORK_TUNNELS_POST_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(data) {
  return {
    type: NETWORK_TUNNELS_POST_REQUEST_SUCCESS,
    data,
  };
}

export function requestFailure(error) {
  return {
    type: NETWORK_TUNNELS_POST_REQUEST_FAILURE,
    error,
  };
}
